export const TURNSTILE_SCRIPT_URL =
  "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

export function getTurnstileSiteKey(value = process.env.VUE_APP_TURNSTILE_SITE_KEY) {
  return typeof value === "string" ? value.trim() : "";
}

export function withTurnstileToken(body, token) {
  const out = { ...body };
  if (typeof token === "string" && token) out.turnstileToken = token;
  return out;
}

export function isCaptchaRequiredError(err) {
  const res = err && err.response;
  return !!(
    res &&
    res.status === 400 &&
    res.data &&
    res.data.errorMessage === "CAPTCHA_REQUIRED"
  );
}

export function createTurnstileLoader({ doc, win, timeoutMs = 10000 }) {
  let pending = null;
  return function load() {
    if (pending) return pending;
    pending = new Promise((resolve, reject) => {
      let settled = false;
      let timer = null;
      const settle = (fn, val) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        if (fn === reject) pending = null;
        fn(val);
      };
      if (win.turnstile) return settle(resolve, win.turnstile);
      const el = doc.createElement("script");
      el.src = TURNSTILE_SCRIPT_URL;
      el.async = true;
      el.defer = true;
      el.onload = () =>
        win.turnstile
          ? settle(resolve, win.turnstile)
          : settle(reject, new Error("Turnstile script loaded without window.turnstile"));
      el.onerror = (e) =>
        settle(reject, e instanceof Error ? e : new Error("Turnstile script failed to load"));
      timer = setTimeout(
        () => settle(reject, new Error("Turnstile load timed out")),
        timeoutMs
      );
      doc.head.appendChild(el);
    });
    return pending;
  };
}

let singleton = null;
export function loadTurnstile() {
  if (!singleton) {
    singleton = createTurnstileLoader({ doc: document, win: window });
  }
  return singleton();
}

export const TURNSTILE_FAIL_OPEN_MS = 15000;

// One-shot watchdog: fires onTimeout if not stopped within ms. start() restarts it.
export function createFailOpenTimer(
  onTimeout,
  { ms = TURNSTILE_FAIL_OPEN_MS, setTimer = setTimeout, clearTimer = clearTimeout } = {}
) {
  let handle = null;
  const stop = () => {
    if (handle !== null) clearTimer(handle);
    handle = null;
  };
  const start = () => {
    stop();
    handle = setTimer(() => {
      handle = null;
      onTimeout();
    }, ms);
  };
  return { start, stop };
}
